import MaterialTable from 'material-table';
import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import moment from 'moment';
import { tableIcons } from '../../helpers';
import { localization, modifyDefaultOptions } from '../../helpers/table';
import useAPI from '../../hooks/useAPI';
import { dateRenderer } from '../../services/formatSvc';
import { mapResponseHistory } from './historyRenderHelper';

export default function KpiHistoryModal({ report, onClose }) {
  const [data, setData] = useState([]);

  const api = useAPI();

  useEffect(async () => {
    const strategyIdParam = report.strategyId ? `?strategyId=${report.strategyId}` : '';
    const responseHistory = await api.get(`/kpis/${report.id}/hists${strategyIdParam}`);
    if (!responseHistory.error) setData(mapResponseHistory(responseHistory));
  }, []);

  const columns = [
    {
      title: 'Дата, время', field: 'createdOn', width: '10%', defaultSort: 'desc', render: (rowData) => moment.utc(rowData.createdOn).format('DD.MM.YYYY HH:mm:ss'),
    },
    { title: 'Пользователь', field: 'userName' },
    { title: 'Действие', field: 'oper', width: '10%' },
    { title: 'Изменение', field: 'changeDescr', render: (rowData) => <div style={{ whiteSpace: 'pre-wrap' }}>{rowData.changeDescr}</div> },
  ];

  return (
    <Modal show={report} size="xl" onHide={onClose}>
      <Modal.Header closeButton>
        История изменений Показателя
        {' '}
        {report.num}
        {' '}
        {report.name}
      </Modal.Header>
      <Modal.Body>
        <MaterialTable
          options={modifyDefaultOptions({
            paging: true, toolbar: false, filtering: false, search: false, tableLayout: 'fixed',
          })}
          localization={localization}
          icons={tableIcons}
          columns={columns}
          data={data}
        />
      </Modal.Body>
      <Modal.Footer>
        {/* <Button disabled={!comment} onClick={handleSubmit} variant="outline-primary">ОК</Button> */}
        <Button onClick={onClose} variant="outline-primary">ОК</Button>
      </Modal.Footer>
    </Modal>
  );
}
